import { render, staticRenderFns } from "./ReviewNewVinculation.vue?vue&type=template&id=025faabc"
import script from "./ReviewNewVinculation.vue?vue&type=script&lang=js"
export * from "./ReviewNewVinculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports